<script setup>

import Dialog from "primevue/dialog";
import DefaultScreen from "../ui-templates/DefaultScreen.vue";
import Button from "primevue/button";
import {computed, inject, reactive, ref, watch} from "vue";
import {router, usePage, WhenVisible} from "@inertiajs/vue3";
import {brightnessByColor, groupSlotsByTime, percentToHex} from "../../../../helpers.js";
import moment from "moment";
import _, {uniq} from "lodash";
import TermsWizardPage from "../wizard/TermsWizardPage.vue";
import {DateTime} from "luxon";
import useAvailability from "../../composables/useAvailability.js";

const componentProps = defineProps({
    theme: Object,
})

const props = usePage().props;
const model = defineModel('visible');
const selectedDay = ref(new Date(Date.parse(props.reservation.date)));
const selectedTimeSlot = ref();
const selectedWorker = ref(props.reservation.id_reservation_workers);
const selectedService = ref(props.reservation.id_services);

const currentBrightness = ref(0);
watch(() => componentProps.theme.panel_color, _.debounce((val) => {
    currentBrightness.value = brightnessByColor(val)
}, 150), {immediate: true})

const form = reactive({
    name: '',
    phone: '',
    email: '',
    note: ''
})

const roundness = computed(() => {
    return {
        '!rounded-none': componentProps.theme.roundness === 0,
        '!rounded-lg': componentProps.theme.roundness === 1,
        '!rounded-xl': componentProps.theme.roundness === 2,
        '!rounded-2xl': componentProps.theme.roundness === 3,
    }
})

const availability = useAvailability();
const availableTimeslots = ref({});
const availableCalendarDates = ref([]);
const dateTimeRestrictions = ref({});

const selectDay = (day) => {
    const date = DateTime.fromJSDate(day).toFormat('yyyy-MM-dd');
    availability.getTimeslots(props.forms, date, selectedWorker.value, selectedService.value).then((timeslots) => {
        availableTimeslots.value = timeslots;
    })
}

watch(selectedWorker, (val) => {
        availability.getDateTimeRestrictions(props.forms, val).then((restrictions) => {
            dateTimeRestrictions.value = restrictions;
            selectDay(selectedDay.value);
        });
    availability.getCalendarDates(props.forms, val, selectedService.value).then((calendarDates) => {
        if (calendarDates.status || !calendarDates) {
            return;
        }
        availableCalendarDates.value = calendarDates;
    })
}, { immediate: true })

watch(selectedDay, (day) => {
    selectDay(day);
}, {immediate: true})


const route = inject('route')
</script>

<template>
    <Dialog v-model:visible="model" modal :show-header="false" unstyled
        pt:mask="bg-black/30 backdrop-blur-xl transition-all"
    >
        <template #container>
            <div class="container max-md:p-8 md:p-12 color-transition transition-all dark:border"
                 :class="[{
            'rounded-xl': theme.roundness === 1,
            'rounded-2xl': theme.roundness === 2,
            'rounded-3xl': theme.roundness === 3,
            'backdrop-filter backdrop-blur-lg': theme.panel_backdrop_blur,
            'border': theme.panel_transparency > 50,
            'border-neutral-700': theme.darkMode
        }]"
                 :style="{
            backgroundColor: `#${theme.panel_color}${percentToHex(theme.panel_transparency)}`
        }">

                    <!-- Změna rezervace -->
                    <p class="pb-5 mb-6 pt-6 max-md:-mt-8 md:-mt-12 max-md:-mx-8 md:-mx-12 max-md:px-8 md:px-12 border-b dark:border-neutral-700 text-xl">
                        {{$t('widget.change_reservation')}}
                    </p>
                    <terms-wizard-page
                        :dateTimeRestrictions="dateTimeRestrictions"
                        :theme="theme"
                        :forms="$page.props.forms"
                        :currentBrightness="currentBrightness"
                        :availableTimeslots="availableTimeslots"
                        :calendarDates="availableCalendarDates"

                        v-model:selectedDay="selectedDay" v-model:form="form"
                        v-model:selectedTimeSlot="selectedTimeSlot"
                    >

                    </terms-wizard-page>
                    <div class="flex justify-center mt-6 -mb-4 gap-3">
                        <!-- Odeslat žádost -->
                        <Button :label="$t('widget.send_request')" :disabled="!selectedTimeSlot" @click="router.post($page.props.reservation.client_url + '/change', {
                            day: selectedDay,
                            timeslot: selectedTimeSlot
                        }, { onSuccess: () => model = false})" icon="pi pi-send" :class="[`!bg-${theme.color}-500 !px-6 !py-3 !border-none hover:!bg-${theme.color}-600`, roundness]"></Button>
                        <!-- Zrušit -->
                        <Button :label="$t('widget.cancel')" icon="pi pi-times" @click="model = false" severity="secondary" :class="roundness"></Button>
                    </div>
            </div>
        </template>
    </Dialog>
</template>

<style scoped lang="scss">

</style>
